/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import type {
  GetCoordinatorsParams,
  GetMyDetailsParams,
  GetMyMembersParams,
  MemberDto,
  PagedResultOfMemberBasicInfoDto
} from '../models';

import { customInstance } from '../axios';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * @summary Gets a member details by ID.
 */
export const getMyDetails = (
    params?: GetMyDetailsParams,
 options?: SecondParameter<typeof customInstance<MemberDto>>,) => {
      return customInstance<MemberDto>(
      {url: `/member-management/coordinators/me`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Gets all members basic info for the current logged-in user (coordinator).
 */
export const getMyMembers = (
    params?: GetMyMembersParams,
 options?: SecondParameter<typeof customInstance<PagedResultOfMemberBasicInfoDto>>,) => {
      return customInstance<PagedResultOfMemberBasicInfoDto>(
      {url: `/member-management/coordinators/me/my-members`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Gets all coordinators basic info.
 */
export const getCoordinators = (
    params?: GetCoordinatorsParams,
 options?: SecondParameter<typeof customInstance<PagedResultOfMemberBasicInfoDto>>,) => {
      return customInstance<PagedResultOfMemberBasicInfoDto>(
      {url: `/member-management/coordinators`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Gets all members basic info for a specific coordinator.
 */
export const getCoordinatorMembers = (
    id: string,
 options?: SecondParameter<typeof customInstance<PagedResultOfMemberBasicInfoDto>>,) => {
      return customInstance<PagedResultOfMemberBasicInfoDto>(
      {url: `/member-management/coordinators/${id}/members`, method: 'GET'
    },
      options);
    }
  export type GetMyDetailsResult = NonNullable<Awaited<ReturnType<typeof getMyDetails>>>
export type GetMyMembersResult = NonNullable<Awaited<ReturnType<typeof getMyMembers>>>
export type GetCoordinatorsResult = NonNullable<Awaited<ReturnType<typeof getCoordinators>>>
export type GetCoordinatorMembersResult = NonNullable<Awaited<ReturnType<typeof getCoordinatorMembers>>>
